// Brand assets. Chef Buddy is the official 3D render with its background removed. Do not redraw or recolour it.
import chefBuddy from "./assets/chef-buddy.webp";
import wordmarkBone from "./assets/wordmark-bone.webp";
import wordmarkInk from "./assets/wordmark-ink.webp";
import wordmarkRed from "./assets/wordmark-red.webp";
import kmarkBone from "./assets/kmark-bone.webp";
import kmarkInk from "./assets/kmark-ink.webp";
import photoRoom from "./assets/photo-room.webp";
import photoChef from "./assets/photo-chef.webp";
import photoTable from "./assets/photo-table.webp";
import photoDish from "./assets/photo-dish.webp";
import photoGuest from "./assets/photo-guest.webp";
import photoOldMenu from "./assets/photo-old-menu.webp";

export const A = {
  chefBuddy, wordmarkBone, wordmarkInk, wordmarkRed, kmarkBone, kmarkInk,
  photoRoom, photoChef, photoTable, photoDish, photoGuest, photoOldMenu,
};
